import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useReturnToAppraisee } from '@/queries/useAppraisalDetail';

interface ReturnToAppraiseeDialogProps {
  open: boolean;
  onClose: () => void;
  appraisalId: string;
  rowVersion?: string;
  onSuccess: () => void;
  onError: (error: unknown) => void;
}

export function ReturnToAppraiseeDialog({
  open,
  onClose,
  appraisalId,
  rowVersion,
  onSuccess,
  onError,
}: ReturnToAppraiseeDialogProps) {
  const { mutate, isPending } = useReturnToAppraisee(appraisalId);

  const handleConfirm = () => {
    mutate(
      { rowVersion },
      {
        onSuccess: () => {
          onSuccess();
        },
        onError: (error) => {
          onError(error);
        },
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Return to Appraisee</DialogTitle>
      <DialogContent>
        <Typography>
          You are about to return this appraisal form to the Appraisee. This will allow them to
          update their self-assessment before resubmitting it for your review.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={isPending}>
          Return to Appraisee
        </Button>
      </DialogActions>
    </Dialog>
  );
}
